import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import CreateDialogueEmbed from '../components/Exercise/CreateDialogueEmbed';

export default Node.create({
  name: 'createDialogueExercise',
  
  group: 'block',
  
  atom: true,
  draggable: true,
  
  addAttributes() {
    return {
      dialogue: {
        default: '',
        parseHTML: element => element.getAttribute('dialogue') || '',
        renderHTML: attributes => {
          if (attributes.dialogue) {
            return {
              dialogue: attributes.dialogue
            };
          }
          return {};
        }
      },
      title: {
        default: 'Create a Dialogue on Any Topic',
        parseHTML: element => element.getAttribute('title') || 'Create a Dialogue on Any Topic',
        renderHTML: attributes => {
          if (attributes.title) {
            return {
              title: attributes.title
            };
          }
          return {};
        }
      },
      level: {
        default: 'B1',
        parseHTML: element => element.getAttribute('level') || 'B1',
        renderHTML: attributes => {
          if (attributes.level) {
            return {
              level: attributes.level
            };
          }
          return {};
        }
      },
      topic: {
        default: '',
        parseHTML: element => element.getAttribute('topic') || '',
        renderHTML: attributes => {
          if (attributes.topic) {
            return {
              topic: attributes.topic
            };
          }
          return {};
        }
      },
      exerciseId: {
        default: null,
        parseHTML: element => element.getAttribute('data-exercise-id') || null,
        renderHTML: attributes => attributes.exerciseId ? { 'data-exercise-id': attributes.exerciseId } : {}
      }
    };
  },
  
  parseHTML() {
    return [
      {
        tag: 'div[data-type="create-dialogue-exercise"]',
      },
    ];
  },
  
  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'create-dialogue-exercise' })];
  },
  
  addNodeView() {
    return ReactNodeViewRenderer(CreateDialogueEmbed);
  },
  
  addCommands() {
    return {
      insertCreateDialogueExercise:
        (attributes = {}) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: attributes,
          });
        },
    };
  },
}); 